module.exports = __webpack_public_path__ + "static/media/1004948.bdf35a5e.png";